export enum NewsAndOffersStatus {
  Draft, Active, Archived
};

export enum NewsAndOffersType {
  News, Offers
};

export type GetNewAndOfferListItemResponseDto = {
  id:	string;
  startDate: Date;
  endDate?: Date;
  title?: string;
  description?:	string;
  type: NewsAndOffersType;
  status:	NewsAndOffersStatus;
  imageUrl?: string;
};

export type GetNewAndOfferListItemResponseDtoListResponseDto = {
  items?: GetNewAndOfferListItemResponseDto[];
  totalCount: number;
};

export type GetNewAndOfferDetailsResponseDto = {
  id:	string;
  startDate: Date;
  endDate?: Date;
  title?: string;
  description?:	string;
  type: NewsAndOffersType;
  status:	NewsAndOffersStatus;
  imageUrl?: string;
};

export type CreateNewAndOfferRequestDto = {
  startDate: Date;
  endDate?: Date;
  title?: string;
  description?:	string;
  type: NewsAndOffersType;
  status:	NewsAndOffersStatus;
};

export type UpdateNewAndOfferRequestDto = {} & CreateNewAndOfferRequestDto;

export type DeleteNewAndOfferRequestDto = string;